export default [
	{
		value: 'Mon',
		label: 'Monday',
		propValue: 'MONDAY',
	},
	{
		value: 'Tue',
		label: 'Tuesday',
		propValue: 'TUESDAY',
	},
	{
		value: 'Wed',
		label: 'Wednesday',
		propValue: 'WEDNESDAY',
	},
	{
		value: 'Thu',
		label: 'Thursday',
		propValue: 'THURSDAY',
	},
	{
		value: 'Fri',
		label: 'Friday',
		propValue: 'FRIDAY',
	},
	{
		value: 'Sat',
		label: 'Saturday',
		propValue: 'SATURDAY',
	},
	{
		value: 'Sun',
		label: 'Sunday',
		propValue: 'SUNDAY',
	},
];
